import classNames from 'classnames';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import React from 'react';

import classes from './modal.module.scss';

function Modal({ isOpen, children, className, ...props }) {
  return (
    isOpen && (
      <motion.div className={classNames(classes.modal, className)} {...props}>
        {children}
      </motion.div>
    )
  );
}

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node,
};

Modal.defaultProps = {
  isOpen: false,
};

export default Modal;
